import { getStore } from '../firebase';

export const createOrder = async (orderDetails) => {
  const { db, addDoc, collection } = await getStore();
  return addDoc(collection(db, 'orders'), orderDetails);
}
